// Single source of truth for Notification content block types - mirrors
// topicBlockTypes.js's convention exactly (type/label/accent/defaultConfig
// per entry). Notification.content is a JSON array of these blocks (see
// communications/renderNotificationBlocks.js for the shared renderer and
// its legacy-plain-string fallback).
export const NOTIFICATION_BLOCK_TYPES = {
   heading: {
      type: 'heading', label: 'Заголовок', accent: '#63dac8',
      // config: {text, align} - a real <h2>, not just bold text
      defaultConfig: { text: '', align: 'left' },
   },
   text: {
      type: 'text', label: 'Текст', accent: '#7ec2e8',
      // config: {text, align} - text carries the existing **bold**/etc
      // markdown-style decoration subset (richText.jsx), align controls the
      // rendered <p>'s text-align
      defaultConfig: { text: '', align: 'left' },
   },
   icon: {
      type: 'icon', label: 'Іконка', accent: '#e0a35c',
      // config: {icon, align, color} - icon is a Material Symbols glyph name
      // (public/index.html loads the font) - see ICON_PALETTE below for the
      // curated picker; any valid Material Symbols name also works typed in
      // directly (fonts.google.com/icons has the full catalog). color is an
      // optional hex string (no '#') - empty means "use the default accent".
      defaultConfig: { icon: 'info', align: 'center', color: '' },
   },
   row: {
      type: 'row', label: 'Рядок', accent: '#b48ead',
      // config: {children} - a small horizontal container: 2+ of the other
      // block types (heading/text/icon) laid out side by side with flexbox.
      // Deliberately one level deep only - a row can't contain another row,
      // to keep editing and rendering simple (see NOTIFICATION_ROW_CHILD_TYPE_LIST).
      defaultConfig: { children: [] },
   },
};

export const NOTIFICATION_BLOCK_TYPE_LIST = Object.values(NOTIFICATION_BLOCK_TYPES);

// The types a Row block is allowed to hold - everything except another row.
export const NOTIFICATION_ROW_CHILD_TYPE_LIST = NOTIFICATION_BLOCK_TYPE_LIST.filter((t) => t.type !== 'row');

export function getNotificationBlockType(type) {
   return NOTIFICATION_BLOCK_TYPES[type] || null;
}

// Curated, announcement-relevant subset of Google's Material Symbols set
// (~2500 icons total - not worth a searchable picker for a first version).
export const ICON_PALETTE = [
   'warning', 'info', 'campaign', 'check_circle', 'event', 'schedule',
   'star', 'priority_high', 'celebration', 'error', 'help', 'lightbulb',
   'flag', 'mail', 'notifications', 'description', 'link', 'calendar_month',
   'group', 'school', 'payments', 'rule', 'lock', 'thumb_up',
];

// Curated icon-color swatches (an empty/unset color falls back to the
// default accent in CSS) plus a native <input type="color"> escape hatch in
// the editor for any other hex value.
export const ICON_COLOR_SWATCHES = ['e0a35c', '7ec2e8', '63dac8', 'e57373', 'ba68c8', 'ffffff'];
